import { ReactNode } from 'react';

export enum CenteredContainerType {
  small,
  large,
}

export type CenteredContainerProps = {
  type?: CenteredContainerType;
  className?: string;
  children: ReactNode | ReactNode[];
};
